<script>
	import SettingsButton from '../Buttons/SettingsButton.svelte';
	import SoundButton from '../Buttons/SoundButton.svelte';
	import TransparentButton from '../Buttons/TransparentButton.svelte';
	import SettingsPopup from '../Popup/SettingsPopup.svelte';

	export let themeSupported = true;
	export let theme = {
		themeName: 'Default Theme',
		themeEmoji: '🎁'
	};
	export let isHost = true;
	export let gameNameSvg = '';
	export let isSoundOn = false;
	export let soundButtonHandler = () => {};
	export let onMouseDown = () => {};
	export let showRules = false;
	export let showSettings = false;
	export let showEndRound = true;
	export let rulesHandler = () => {};
	export let themesHandler = () => {};
	export let endGameonClick = () => {};
	export let endRoundonClick = () => {};
</script>

<div class="headerContainer">
	<div class="innerContainer">
		<div class="left">
			<SoundButton height="30" onClick={soundButtonHandler} {isSoundOn} />
			{#if themeSupported}
				<TransparentButton
					width="96"
					height="30"
					fontSize="15"
					text={theme.themeName}
					emoji={theme.themeEmoji}
					disabled={false}
					onClick={themesHandler}
					{onMouseDown}
				/>
			{/if}
		</div>
		<div class="centerGameNameSvg">
			<img src={`${gameNameSvg}`} alt={gameNameSvg} />
		</div>
		<div class="right">
			{#if showRules}
				<TransparentButton
					width="87"
					height="30"
					fontSize="16"
					text="Rules"
					emoji="🎲"
					disabled={false}
					onClick={rulesHandler}
					{onMouseDown}
				/>
			{/if}
			{#if isHost && showSettings}
				<SettingsButton
					height="30"
					{showEndRound}
					{endGameonClick}
					{endRoundonClick}
					{onMouseDown}
				/>
			{/if}
		</div>
	</div>
</div>

<style>
	div.headerContainer {
		position: absolute;
		width: 100%;
		height: 100px;
	}
	div.innerContainer {
		display: flex;
		justify-content: space-between;
		position: relative;
		flex-direction: row;
		width: 100%;
		align-items: center;
		padding: 2%;
		margin: auto;
		height: 100%;
	}

	.left,
	.right {
		display: flex;
		justify-content: center;
		align-items: center;
		column-gap: 8px;
	}

	.centerGameNameSvg {
		position: absolute;
		left: 50%;
		transform: translate(-50%);
	}
	.centerGameNameSvg > img {
		width: 142px;
		height: 67px;
	}
</style>
